import { render, staticRenderFns } from "./ResourceDescription.vue?vue&type=template&id=4480c48d&scoped=true&"
import script from "./ResourceDescription.vue?vue&type=script&lang=ts&"
export * from "./ResourceDescription.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceDescription.vue?vue&type=style&index=0&id=4480c48d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480c48d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4480c48d')) {
      api.createRecord('4480c48d', component.options)
    } else {
      api.reload('4480c48d', component.options)
    }
    module.hot.accept("./ResourceDescription.vue?vue&type=template&id=4480c48d&scoped=true&", function () {
      api.rerender('4480c48d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/resource-details/ResourceDescription.vue"
export default component.exports